import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Request from "../../utils/http";

import { toast } from "react-toastify";
const request = new Request();

function ActivateMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const activar = () => {
    sendActivar(1);
  };
  const desactivar = () => {
    sendActivar(0);
  };

  const reload = () => {
    props.reload();
    setAnchorEl(null);
  };

  const sendActivar = async (dato) => {
    let token1 = JSON.parse(sessionStorage.getItem("decoAdmin"));
    let token;
    if (token1) {
      token = token1.id;
    }
    let data = {
      token: token,
      idSup: props.value,
      activo: dato
    };
    const response = await request.post("/auth/operations/statuSupervisor", data);
    
    if (response && !response.error) {
      if (response.result && !response.empty) {
        toast.success(
          <span>
             Se{" "}
            {data.activo === 0 ? "desactivo" : "activo"} el artículo con id:"
            {data.idArt}" correctamente.
          </span>
        );
        reload();
      } else {
        toast.error(
          <span>
            "UPSS!!!, algo salio
            mal.. intentalo de nuevo, si el problema continua contacta a
            sistemas."
          </span>
        );
      }
    } else {
      toast.error(
        <span>
          "UPSS!!!, algo salio
          mal.. intentalo de nuevo, si el problema continua contacta a
          sistemas."
        </span>
      );
    }
  };

  return (
    <>
      <button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        className="btn btn-info bg-gradient-info"
        size="small"
      >
        <i className="fas fa-sort-down"></i>
      </button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={desactivar}>
          <i className="fas fa-eye-slash" style={{ color: "#b71c1c" }}></i>
          &nbsp;Desactivar
        </MenuItem>
        <MenuItem onClick={activar}>
          <i className="fas fa-eye" style={{ color: "#4caf50" }}></i>
          &nbsp;Activar
        </MenuItem>
      </Menu>
    </>
  );
}
export default ActivateMenu;
